(() => {
  const mobile = matchMedia('(max-width: 900px)');
  const header = document.querySelector('.w-header');
  const shell = header?.closest('.shopify-section');
  const menu = header?.querySelector('.w-mobile-menu');
  if (!shell || !menu) return;
  shell.classList.add('w-mobile-header');
  let lastY = window.scrollY, travel = 0, frame = 0, lockedY = null;
  const backgrounds = [...document.querySelectorAll('#MainContent, .w-footer')];
  const previousInert = new Map();
  const reveal = () => { shell.classList.remove('w-header-away'); travel = 0; };
  const update = () => {
    frame = 0;
    const y = Math.max(0, window.scrollY), delta = y - lastY;
    travel = Math.sign(delta) === Math.sign(travel) ? travel + delta : delta;
    lastY = y;
    if (!mobile.matches || menu.open || lockedY !== null || y < 100 || header.querySelector(':focus-visible')) return reveal();
    if (travel > 24) shell.classList.add('w-header-away');
    if (travel < -12) reveal();
  };
  window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive:true});
  header.addEventListener('focusin', reveal);
  const syncMenu = () => {
    const open = mobile.matches && menu.open;
    menu.querySelector('summary').setAttribute('aria-expanded', String(open));
    if (open && lockedY === null) {
      reveal();
      lockedY = window.scrollY;
      document.body.style.setProperty('--w-locked-top', `-${lockedY}px`);
      document.body.classList.add('w-menu-locked');
      backgrounds.forEach(el => { previousInert.set(el, el.inert); el.inert = true; });
    } else if (!open && lockedY !== null) {
      const y = lockedY;
      lockedY = null;
      document.body.classList.remove('w-menu-locked');
      document.body.style.removeProperty('--w-locked-top');
      backgrounds.forEach(el => { el.inert = previousInert.get(el) || false; });
      window.scrollTo({top:y, behavior:'instant'});
      lastY = y;
      reveal();
    }
  };
  menu.addEventListener('toggle', syncMenu);
  menu.addEventListener('click', event => {
    if (event.target.closest('a')) { menu.open = false; syncMenu(); }
  });
  menu.addEventListener('keydown', event => {
    if (!mobile.matches || !menu.open || event.key !== 'Tab') return;
    const items = [...menu.querySelectorAll('summary, a[href], button, select')].filter(el => el.getClientRects().length);
    const first = items[0], last = items.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  mobile.addEventListener('change', () => { if (!mobile.matches) menu.open = false; syncMenu(); reveal(); });
  window.addEventListener('pageshow', () => { menu.open = false; syncMenu(); reveal(); });
})();
